export const tabKey = Symbol('tabs')
